import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Clock, Tag } from "lucide-react";
import { ARTICLES } from "../lib/articles";
import TireImage from "./TireImage";
import Reveal from "./Reveal";

export const GuiasIndex = () => {
  return (
    <section
      data-testid="guias-index"
      className="relative pt-28 pb-14 md:pt-32 md:pb-16 bg-[#0E2452] border-t border-[#2F568F]"
    >
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8">
            <div>
              <span className="section-label flex items-center gap-2">
                <BookOpen className="w-4 h-4" />
                // Guias para Entusiastas
              </span>
              <h1 className="font-display font-bold text-white text-3xl md:text-4xl lg:text-5xl uppercase tracking-tight mt-3 leading-[0.98]">
                Saber escolher
                <br />
                <span className="text-[#FF5A00]">faz toda a diferença.</span>
              </h1>
            </div>
            <p className="text-[#A1A1AA] font-body text-sm md:text-base max-w-md">
              Comparativos, guias técnicos e conselhos para quem leva os
              pneus a sério. Baseado na nossa experiência de oficina e em
              testes independentes.
            </p>
          </div>

          {/* Articles grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {ARTICLES.map((a, idx) => (
              <Reveal key={a.slug} delay={idx * 120}>
                <Link
                  to={`/guias/${a.slug}`}
                  data-testid={`guia-card-${a.slug}`}
                  className="group glass-soft hover:border-[#FF5A00] transition-all duration-300 hover:-translate-y-1 flex flex-col h-full"
                >
                  <div className="bg-[#0E2452] border-b border-[#2F568F] p-6 flex items-center justify-center h-44">
                    <TireImage
                      src={a.image}
                      alt={a.title}
                      className="w-full h-full flex items-center justify-center"
                      imgClassName="max-h-full max-w-full object-contain drop-shadow-[0_15px_30px_rgba(0,0,0,0.6)] group-hover:scale-105 transition-transform duration-500"
                      skeletonShape="rect"
                    />
                  </div>

                <div className="p-5 flex-1 flex flex-col">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] text-[#FF5A00] font-display font-bold">
                      <Tag className="w-3 h-3" />
                      {a.tag}
                    </span>
                    <span className="text-[#5A7AAE]">·</span>
                    <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] text-[#A1A1AA] font-display">
                      <Clock className="w-3 h-3" />
                      {a.readTime}
                    </span>
                  </div>

                  <h2 className="font-display font-bold text-white text-lg md:text-xl uppercase tracking-tight leading-tight mb-2 group-hover:text-[#FF5A00] transition-colors">
                    {a.title}
                  </h2>

                  <p className="text-[#A1A1AA] font-body text-sm leading-relaxed flex-1 mb-4">
                    {a.excerpt}
                  </p>

                  <span className="inline-flex items-center gap-2 text-[#FF5A00] font-display font-bold uppercase text-xs tracking-widest">
                    Ler artigo
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
                </Link>
              </Reveal>
            ))}
          </div>

          {/* Bottom note */}
          <p className="text-[11px] text-[#5A7AAE] font-body mt-6 leading-relaxed">
            Novos artigos publicados todos os meses. Sugestões de temas?{" "}
            <Link to="/orcamento" className="text-[#FF5A00] hover:text-white transition-colors">
              Envie-nos uma mensagem
            </Link>
            .
          </p>
        </div>
      </div>
    </section>
  );
};

export default GuiasIndex;
